import React, { useState, useEffect, useCallback } from 'react';
import * as Yup from "yup";
import MobileProductForm from './MobileProductDetailsForm'
import { Paper, withStyles, Grid } from "@material-ui/core";
import { hasPermission, parseURL } from '../../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "../store/mobileProductActions";
import ExternalTable from '../../ExternalSystemSetting'
const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '5px',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const MobileProductEdit = props => {
    const { external, setLoading, setExternal, product, loading, editable, classes, gradingCategories, grades, typicalProblems, activeCustomer, translations, permissions } = props;
    let searchParams = parseURL(window.location.search);
    const [editData, setEditData] = useState({ formattedTypicalProblems: [], loadingData: true });
    const formatPermissions = useCallback(async (typicalProblems = [], TypicalProblems = []) => {
        let TypicalProblemsIDs = TypicalProblems.map(typicalProblems => typicalProblems.TypicalProblemID);
        return typicalProblems.filter(typicalProblems => TypicalProblemsIDs.includes(typicalProblems.value));
    }, [])

    const formatTypicalProblemsData = useCallback(async () => {
        let formattedTypicalProblems = await formatPermissions(typicalProblems, product && product.TypicalProblems instanceof Array ? product.TypicalProblems : []);
        setEditData({ formattedTypicalProblems: formattedTypicalProblems, loadingData: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product, typicalProblems])

    useEffect(() => {
        if (typicalProblems.length > 0) {
            formatTypicalProblemsData(product);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product, typicalProblems]);

    const extractTypicalProblem = selectedPermission => {
        return selectedPermission.map(permission => permission.value);
    }

    const handleSubmit = async data => {
        data['ActiveCustomerID'] = activeCustomer;
        data['updateMISCOnly'] = false;
        data['TypicalProblemIDs'] = extractTypicalProblem(data.TypicalProblemID);
        data['ProductID'] = searchParams.productID;
        await props.onEditProduct({ ...data });
    }

    const initialValues = {
        InventoryID: product && product.InventoryID ? product.InventoryID : '-',
        InventoryNumber: product && product.InventoryNumber ? product.InventoryNumber : '-',
        SKU: product?.SKU ?? '-',
        Order: product && product.Order && product.Order.Name ? product.Order.Name : '-',
        TransportColli: product && product.TransportColli && product.TransportColli.Name ? product.TransportColli.Name : '-',
        Colli: product && product.Colli && product.Colli.Name ? product.Colli.Name : '',
        SerialNumber: product && product.SerialNumber ? product.SerialNumber : '',
        IMEI: product && product.MobileProduct && product.MobileProduct.IMEI ? product.MobileProduct.IMEI : '-',
        IMEI2: product && product.MobileProduct && product.MobileProduct.IMEI2 ? product.MobileProduct.IMEI2 : '-',
        Vendor: product && product.Vendor ? product.Vendor : '',
        MobileProductModel: product && product.MobileProduct && product.MobileProduct.MobileProductModel ? product.MobileProduct.MobileProductModel : '-',
        InternalName: product && product.MobileProduct && product.MobileProduct.InternalName ? product.MobileProduct.InternalName : '',
        GradingCategoryID: gradingCategories.filter(grading => grading.value?.toString() === (product && product.GradingCategoryID?.toString() ? product.GradingCategoryID?.toString() : '')).length > 0 ? product && product.GradingCategoryID?.toString() ? product.GradingCategoryID?.toString() : gradingCategories.length > 0 ? gradingCategories[0].value?.toString() : '' : '',
        GradeID: grades.filter(grading => grading.value === (product && product.GradeID ? product.GradeID : '')).length > 0 ? product && product.GradeID ? product.GradeID : 'A' : '',
        LabelComment1: product && product.LabelComment1 ? product.LabelComment1 : '',
        LabelComment2: product && product.LabelComment2 ? product.LabelComment2 : '',
        LabelComment3: product && product.LabelComment3 ? product.LabelComment3 : '',
        LabelComment4: product && product.LabelComment4 ? product.LabelComment4 : '',
        TypicalProblemID: editData.formattedTypicalProblems,
        Notes: product && product && product.Notes ? product.Notes : '',
        Group: (product && product.Group?.Name) || translations['none'] || "None",
    };
    const formSettings = {
        Validation: {
            InventoryID: Yup.string().required(),
        },
        ButtonSubmit: hasPermission(permissions, "product_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    return (
        <Grid container className={classes.root} spacing={1}>
            <Grid item xs={hasPermission(permissions, 'product_external_info_view') && props.activeExternalServiceAvailable ? 6 : 12}>

                <Paper className={classes.root} >
                    {editData.loadingData ?
                        <MobileProductForm
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        grades={grades}
                        editable={editable}
                        typicalProblems={typicalProblems}
                        gradingCategories={gradingCategories}
                        loading={loading}
                        translations={translations}
                        /> : <></>}
                </Paper>
            </Grid>
            {hasPermission(permissions, 'product_external_info_view') && props.activeExternalServiceAvailable ?
                <Grid style={{ marginTop: '9px' }} item xs={6}>
                    {product && product.ProductExternalInfo && product.ProductExternalInfo instanceof Array ? <ExternalTable onUnpairBulkExternalPC={props.onUnpairBulkExternalMobile} onUnpairExternalPC={props.onUnpairExternalMobile} translations={translations} product={product} permissions={permissions} onFetchProduct={props.onFetchProduct} saveColumnsFilter={props.saveColumnsFilter} setExternal={setExternal} setLoading={setLoading} external={external} activeCustomer={activeCustomer} /> : null}
                </Grid>
                : null}
        </Grid>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditProduct: mobileProduct => dispatch(actions.editMobileProduct(mobileProduct)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MobileProductEdit));
